import { MailCheck, ShieldCheck } from "lucide-react";
import { FormEvent, useState } from "react";
import { api, ApiError } from "../lib/api";
import { Link } from "../lib/router";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api("/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch (cause) {
      if (cause instanceof ApiError && cause.status === 429) {
        setError("Demasiadas tentativas. Tente novamente dentro de 15 minutos.");
      } else {
        setError("Não foi possível enviar o email de recuperação.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-visual">
        <div className="login-visual__grid" />
        <div className="login-brand">
          <img src="/brand/pagaqui.svg" alt="PAGAQUI" />
          <span>Pagaqui Wallet - Backoffice</span>
        </div>
        <div className="login-visual__copy">
          <span className="eyebrow eyebrow--light">
            Pagaqui Wallet - Backoffice
          </span>
          <h1>Recuperar acesso à tua conta.</h1>
          <p>Enviamos um link seguro para redefinires a tua palavra-passe.</p>
        </div>
        <div className="security-note">
          <ShieldCheck size={20} />
          <span>O link expira ao fim de 1 hora.</span>
        </div>
      </section>

      <section className="login-panel">
        {sent ? (
          <div className="login-form">
            <div className="login-form__icon">
              <MailCheck size={24} />
            </div>
            <span className="eyebrow">Verifica o teu email</span>
            <h2>Email enviado</h2>
            <p>
              Se existir uma conta associada a <strong>{email}</strong>,
              vais receber um email com instruções para redefinir a
              palavra-passe.
            </p>
            <Link className="button button--primary button--full" to="/login">
              Voltar ao login
            </Link>
          </div>
        ) : (
          <form className="login-form" onSubmit={submit}>
            <div className="login-form__icon">
              <MailCheck size={24} />
            </div>
            <span className="eyebrow">Esqueceste-te da password?</span>
            <h2>Recuperar palavra-passe</h2>
            <p>Indica o teu email profissional para receberes o link de recuperação.</p>

            <label>
              Email profissional
              <input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="nome@pagaqui.pt"
                required
                autoFocus
              />
            </label>

            {error && (
              <div className="form-error" role="alert">
                {error}
              </div>
            )}

            <button
              className="button button--primary button--full"
              disabled={busy}
            >
              {busy ? (
                <span className="spinner spinner--button" />
              ) : (
                "Enviar link de recuperação"
              )}
            </button>
            <Link to="/login">Voltar ao login</Link>
          </form>
        )}
      </section>
    </main>
  );
}
